class ZetaSuggestApi extends ZetaApi {
  #path = "api/suggest";
  #limit = 5;
  #q_word = "";
  #callback = null;

  #keywordList;
  #categoryList;
  #brandList;

  constructor() {
    super();
    super.endPoint = this.#path;
  }

  async request() {
    this.#setParams();
    const response = await super.request();
    this.#setData(response);
  }

  set keyword(q) {
    this.#q_word = q;
  }

  get keywordList() {
    return this.#keywordList;
  }

  get categoryList() {
    return this.#categoryList;
  }

  get brandList() {
    return this.#brandList;
  }

  #setParams() {
    this.deleteInsertParam("q_word", this.#q_word);
    this.deleteInsertParam("limit", this.#limit);
    this.deleteInsertParam("callback", this.#callback ?? "");
  }

  #setData(response) {
    this.#keywordList = response.keyword;
    this.#categoryList = response.category;
    this.#brandList = response.brand;
  }
}
